import { Pipe, PipeTransform } from '@angular/core';
import { MessageKind } from '@clientwire/api';

@Pipe({
  name: 'fileKind',
  standalone: true,
})
export class KindPipe implements PipeTransform {
  #allowedFileTypes: MessageKind[] = ['IMAGE', 'VIDEO', 'AUDIO'];
  transform(fileType: string): MessageKind | null {
    const fileKind = fileType.split('/')[0]?.toUpperCase();
    if (this.#allowedFileTypes.includes(fileKind as MessageKind)) {
      return fileKind as MessageKind;
    }
    return null;
  }
}
